import React, { FC } from 'react'

import { SideScrollContainer } from '@components/shared/containers/SideScrollContainer'
import Collection from '@models/Collection'
import { CollectionTitleItem } from '@models/CollectionItem'
import Title from '@models/Title'

import CoverArtItem from './CoverArtItem'

interface CollectionTitlesProps {
  collection: Collection<CollectionTitleItem>
}
/**
 *
 * Wrapper for a collection of titles on the Music/BrowsePage
 *
 */
export const CollectionTitles: FC<CollectionTitlesProps> = ({
  collection,
}: CollectionTitlesProps): JSX.Element => {
  return (
    <section className="flex flex-col my-5" data-testid={`collection-${collection.id}`}>
      <h1 className="mb-6 text-xl font-semibold md:text-h3">{collection.name}</h1>
      <SideScrollContainer className="flex">
        {(collection.items ?? []).map((item) => {
          const key = `item-${item.id}`
          return (
            <CoverArtItem
              title={new Title(item)}
              key={key}
              data-testid={key}
              className="inline-block mr-5 mb-0 max-w-[163px] min-w-[163px] w-full"
            />
          )
        })}
      </SideScrollContainer>
    </section>
  )
}
